// extracted by mini-css-extract-plugin
module.exports = {"footer-row":"footer-row_footer-row__kjQ9H","gray":"footer-row_gray__47YuN","footer-row-container":"footer-row_footer-row-container__vhiyw"};